/**
 * Pagina lista processi attività
 * @module Pages/Admin/Processi/List
 */

import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { useCQuery } from '../../../../Services/QueryCache'
import { useNavigate } from 'react-router-dom'
import { Button, Flex, Modal, Spinner, Text } from '../../../../Components'
import { Column } from 'primereact/column'
import { deleteProcesso, restoreProcesso } from '../Functions'
import { columnProps } from '../../../../Services/Functions'
import { Checkbox } from 'primereact/checkbox'

export function ProcessiList () {
  const [showDeleted, setShowDeleted] = useState(false)
  const { data: processi = [], isSuccess } = useCQuery(['processiAttivita', showDeleted ? 'true' : 'false'])
  const [processiTable, setProcessiTable] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    isSuccess && setProcessiTable(processi.map((r) => r))
  }, [processi, isSuccess])

  const BtnActions = ({ id, deleted }) => {
    const [modalVisible, setModalVisible] = useState(false)
    return (
      <Flex width={160} row>
        <Modal visible={modalVisible} header='Disabilitazione Processo' onHide={() => setModalVisible(false)}>
          <Flex fw>
            <Text value='Vuoi disabilitare questo processo?' />
            <Flex fw row jb style={{ marginTop: 20 }}>
              <Button label='Annulla' icon='fa-duotone fa-times' onClick={() => setModalVisible(false)} />
              <Button label='Conferma' icon='fa-duotone fa-check' onClick={() => { deleteProcesso(id); setModalVisible(false) }} />
            </Flex>
          </Flex>
        </Modal>
        <Button round tooltip='Modifica' icon='fa-duotone fa-pen' onClick={() => navigate('/admin/processi/' + id)} />
        {deleted
          ? <Button style={{ marginLeft: 20 }} round tooltip='Riabilita' icon='fa-duotone fa-undo' onClick={() => restoreProcesso(id)} />
          : <Button style={{ marginLeft: 20 }} round tooltip='Disabilita' icon='fa-duotone fa-ban' onClick={() => setModalVisible(true)} />}
      </Flex>
    )
  }

  if (!isSuccess) return <Spinner />
  return (
    <Flex fw fh js>
      <Flex fw row jb ae>
        <Text value='Lista Processi' size={20} bold />
        <Flex row>
          <Flex row style={{ marginRight: 20 }}>
            <Text value='Mostra disabilitati' style={{ marginRight: 10 }} />
            <Checkbox checked={showDeleted} onChange={(e) => setShowDeleted(e.checked)} />
          </Flex>
          <Button label='Crea Nuovo' icon='fa-duotone fa-plus' onClick={() => navigate('/admin/processi/new')} />
        </Flex>
      </Flex>
      <DataTable
        style={{ width: '100%', marginTop: 20 }} filterDisplay='row' sortField='codice' sortOrder={1} className='TableSignatures'
        value={processiTable} emptyMessage='Nessun processo trovato' responsiveLayout='scroll' paginator rows={10}
      >
        <Column field='codice' {...columnProps('Codice')} />
        <Column field='descrizione' {...columnProps('Descrizione')} />
        <Column field='deleted' {...columnProps('Stato')} body={({ deleted }) => deleted ? 'Disabilitato' : 'Attivo'} />
        <Column style={{ border: 'none', width: 140, height: 15, textAlign: 'center' }} body={(props) => <BtnActions {...props} />} />
      </DataTable>
    </Flex>
  )
}
